import { z } from 'zod';

import { userSchema } from '../../user/types';

export const dispatcherSchema = z.object({
    dispatcher_id: z.number(),
    notificationEmail: z.boolean().default(false),
    notificationWhatsapp: z.boolean().default(false),
    deleted: z.boolean().default(false),
    token: z.string().nullable(),
    // Where communication goes. Not unique - several dispatchers of one carrier
    // may share a company mailbox. Login runs on user.email instead.
    //
    // Three soft-deleted legacy rows carry an empty string - they never had an
    // address of any kind. The backend's soft-delete middleware keeps them out
    // of every read, nested ones included, so they never reach here.
    contactEmail: z.string().email(),
    carrier_id: z.number(),
    user_id: z.number(),
});
export type TDispatcher = z.infer<typeof dispatcherSchema>;

export const extendedDispatcherSchema = dispatcherSchema.extend({
    user: userSchema,
});
export type TExtendedDispatcher = z.infer<typeof extendedDispatcherSchema>;
